export const LEAD_GENERATION_HEADER = {
  referenceId: 'Booking Number',
  studentName: 'Student Name',
  studentEmail: 'Email Address',
  city: 'City',
  propertyName: 'Property name',
  moveInDate: 'Move-in Date',
  moveOutDate: 'Move-out Date',
  createdDate: 'Create Date',
  roomName: 'Room Name',
  unitPrice: 'Unit Price',
  totalRent: 'Total Rent',
  commissionTotal: 'Total Commission',
  commissionTierValue: 'Commission Tier',
  status: ' Current Status',
  invoiceNumber: 'Invoice Number',
  invoicedAt: 'Invoice at',
};

export const SEMI_AUTOMATIC_HEADER = {
  referenceId: 'Booking Number',
  studentName: 'Student Name',
  studentEmail: 'Email Address',
  city: 'City',
  propertyName: 'Property name',
  moveInDate: 'Move-in Date',
  moveOutDate: 'Move-out Date',
  createdDate: 'Create Date',
  completedDate: 'Complete Date',
  roomName: 'Room Name',
  unitPrice: 'Unit Price',
  totalRent: 'Total Rent',
  commissionTotal: 'Total Commission',
  commissionTierValue: 'Commission Tier',
  status: ' Current Status',
  invoiceNumber: 'Invoice Number',
  invoicedAt: 'Invoice at',
};

export const INSTANT_BOOK_HEADER = {
  referenceId: 'Booking Number',
  studentName: 'Student Name',
  studentEmail: 'Email Address',
  city: 'City',
  propertyName: 'Property name',
  moveInDate: 'Move-in Date',
  moveOutDate: 'Move-out Date',
  roomName: 'Room Name',
  unitPrice: 'Unit Price',
  totalRent: 'Total Rent',
  commissionTotal: 'Total Commission',
  commissionTierValue: 'Commission Tier',
  status: ' Current Status',
  invoiceNumber: 'Invoice Number',
  invoicedAt: 'Invoice at',
};
